import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row
} from "reactstrap";
import i18n from "../../../i18n";
import { map } from "lodash";
import { delEmployeesAdminDelete } from "../../../helpers/api_rombo_helper";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";

const DeleteBulkModal = ({ isOpen, toggle, setDeleteBulkModal, setShowAlertSuccess, setTextHeader, setTextBody, checkDeleteEmployees, setCheckDeleteEmployees, setReloadEmployee, reloadEmployee, token, setClickDeleteEmployee }) => {

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  function onClickSave() {
    let body = [];
    checkDeleteEmployees.map((checkDeleteEmployee, index) => {
      body.push({ id: checkDeleteEmployee.id, status: "DELETED" })
    })
    delEmployeesAdminDelete(token, { ids: body })
      .then((response) => {
        setDeleteBulkModal(false)
        setShowAlertSuccess(true)
        setClickDeleteEmployee(false)
        setReloadEmployee(!reloadEmployee)
        setCheckDeleteEmployees([])
        setCheckDeleteEmployees([])
        setTextHeader(i18n.t("DeletedEmployee"))
        setTextBody(i18n.t("SuccessDeletedEmployee"))
      })
      .catch((error) => {
        console.error("Error - delEmployeesAdminDeleteBulk -", error)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
        setErrorAlert(true)
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DeleteEmployee")}</p>
        <p className="cancellation-confirmation modal-header-bottom">{i18n.t("Confirmation")}</p>
        <div className="modal-separator"></div>
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert} text={errorAlertMessage} />
          <Row>
            <p/>
            <p className="cancellation-text">{i18n.t("TextDeleteEmployee")}</p>
            {map(checkDeleteEmployees, (checkDeleteEmployee, key) => (
              <p className="cancellation-text" key={key}> - {checkDeleteEmployee.name + " (" + checkDeleteEmployee.email + ")" }</p>
            ))}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={onClickSave}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={() => {
              setCheckDeleteEmployees([])
              setDeleteBulkModal(false)
            }}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteBulkModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setDeleteBulkModal: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  setClickDeleteEmployee: PropTypes.func,
  setCheckDeleteEmployees: PropTypes.func,
  setReloadEmployee: PropTypes.func,
  reloadEmployee: PropTypes.bool,
  token: PropTypes.object,
  checkDeleteEmployees: PropTypes.array
}

export default DeleteBulkModal;
